import { ScopeHeadCellData } from "@domain/Interfaces/HeadCellData.d";
import { ScopeHeadCell } from "@domain/Interfaces/HeadCell.d";
import { TableHead, TableRow, TableCell, TableSortLabel, useTheme } from "@mui/material";
import Order from "@domain/Interfaces/Order.d";
import { StyledArrowSortIcon, StyledArrowUpIcon, StyledArrowDownIcon } from "@presentation/components/TotalFilterIcon";
import { useTranslation } from "react-i18next";

interface TotalScopeHeadProps {
  onRequestSort: (event: React.MouseEvent<unknown>, property: keyof ScopeHeadCellData) => void;
  order: Order;
  orderBy: string;
  headCells: ScopeHeadCell[];
}

const TotalTableHead = ({ order, orderBy, onRequestSort, headCells }: TotalScopeHeadProps): JSX.Element => {
  const theme = useTheme();
  const createSortHandler = (property: keyof ScopeHeadCellData) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property);
  };

  const { t } = useTranslation();

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell: ScopeHeadCell) => {
          let iconComponent = StyledArrowSortIcon;
          if (orderBy === headCell.id && order === "asc") {
            iconComponent = StyledArrowUpIcon;
          } else if (orderBy === headCell.id) {
            iconComponent = StyledArrowDownIcon;
          }
          return (
            <TableCell
              key={headCell.id}
              align="left"
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              {headCell.enableSorting ? (
                <TableSortLabel
                  active
                  sx={{ color: orderBy === headCell.id ? theme.palette.secondary.main : "inherit" }}
                  IconComponent={iconComponent}
                  onClick={
                    headCell.enableSorting ? createSortHandler(headCell.id as keyof ScopeHeadCellData) : () => undefined
                  }
                >
                  {headCell.label}
                </TableSortLabel>
              ) : (
                headCell.label
              )}
            </TableCell>
          );
        })}
        <TableCell align="right">{t("manage_scopes.headers.actions")}</TableCell>
      </TableRow>
    </TableHead>
  );
};

export default TotalTableHead;
